import PLAN from '../database/plan';

class PlanModel {
  constructor(professionId, planType, courseId) {
    this.professionId = professionId;
    this.planType = planType;
    this.courseId = courseId;
  }

  // 获取所有计划
  static getAllPlan() {
    return PLAN;
  }

  // 根据 professionId 获取 plan
  static getPlanByProfessionId(pid) {
    for (let i = 0, { length } = PLAN; i < length; i += 1) {
      if (PLAN[i].professionId === pid) {
        return PLAN[i];
      }
    }
    return {};
  }

  // 根据 professionId, planType 获取 某一确认计划
  static getPlan(pid, type) {
    const result = this.getPlanByProfessionId(pid);
    const planList = result.detail;
    for (let i = 0, { length } = planList; i < length; i += 1) {
      if (planList[i].type === type) {
        return planList[i];
      }
    }
    return {};
  }

  // 获得计划的阶段名字列表
  static getPlanStageNameList(pid, type) {
    const plan = this.getPlan(pid, type);
    const { stage } = plan.start;
    const list = [];
    stage.forEach((item) => {
      list.push(item.name);
    });
    return list;
  }
}

export default PlanModel;
